import { create } from 'zustand';
import type { EditorState, EditorStore } from '../types/editor';

const initialState: EditorState = {
  content: '',
  fileName: 'untitled.md',
  isPreviewVisible: true,
  isFullscreen: false,
  isDirty: false,
};

export const useEditorStore = create<EditorStore>((set) => ({
  ...initialState,
  
  setContent: (content) => 
    set((state) => ({ content, isDirty: content !== state.content })),
    
  setFileName: (fileName) => 
    set({ fileName }),
    
  togglePreview: () => 
    set((state) => ({ isPreviewVisible: !state.isPreviewVisible })),
    
  toggleFullscreen: () => 
    set((state) => ({ isFullscreen: !state.isFullscreen })),
    
  setDirty: (isDirty) => 
    set({ isDirty }),
    
  loadFile: (content, fileName) => 
    set({ content, fileName, isDirty: false }),
    
  reset: () => 
    set(initialState),
}));